export default __webpack_public_path__ + "static/media/foto-diferencial.41202403.png";